// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._yv0eloeq{grid-template-columns:repeat(7,minmax(max-content,1fr))}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/calendar/dist/esm/internal/components/week-day-grid.compiled.css"],"names":[],"mappings":"AAAA,WAAW,uDAAuD","sourcesContent":["._yv0eloeq{grid-template-columns:repeat(7,minmax(max-content,1fr))}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
